import React from 'react';
import { fetchInTimeOptionEnd, fetchInTimeOptionStart } from '../../../../businessLogic/operatingDaysAndHours';

export default function CenterPanelView(props) {
  const getDayNames = ({
    isMondaySelected,
    isTuesdaySelected,
    isWednesdaySelected,
    isThursdaySelected,
    isFridaySelected,
    isSaturdaySelected,
    isSundaySelected,
  }) => {
    let dayNames = [];

    isMondaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.MondayText) : '';
    isTuesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.TuesdayText) : '';
    isWednesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.WednesdayText) : '';
    isThursdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.ThursdayText) : '';
    isFridaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.FridayText) : '';
    isSaturdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SaturdayText) : '';
    isSundaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SundayText) : '';
    return dayNames.join(', ');
  };
  const getShortDayNames = ({
    isMondaySelected,
    isTuesdaySelected,
    isWednesdaySelected,
    isThursdaySelected,
    isFridaySelected,
    isSaturdaySelected,
    isSundaySelected,
  }) => {
    let dayNames = [];

    isMondaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.MondayShort) : '';
    isTuesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.TuesdayShort) : '';
    isWednesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.WednesdayShort) : '';
    isThursdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.ThursdayShort) : '';
    isFridaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.FridayShort) : '';
    isSaturdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SaturdayShort) : '';
    isSundaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaOperatingHours.SundayShort) : '';
    return dayNames.join(', ');
  };

  const getTimeZoneText = () => {
    if (props.timezones && props.timezones.length > 0) {
      const timeZone = props.timezones.find((x) => x.value == props.waitingAreaOperatingHoursForm.serviceTimeZone);
      if (timeZone) return timeZone.text;
      return props.waitingAreaOperatingHoursForm.serviceTimeZone;
    } else {
      return '';
    }
  };

  let serviceAvailibilty = '';
  serviceAvailibilty = props.waitingAreaOperatingHoursForm.serviceOfferingAvailabilities.map((option, i) => {
    return (
      <div className="mrbs" key={i}>
        <div>{fetchInTimeOptionStart(option.fromTime) + ' to ' + fetchInTimeOptionEnd(option.toTime)}</div>
        <div className="hide-on-small-ress">{getDayNames(option)}</div>
        <div className="show-on-small-ress ">{getShortDayNames(option)}</div>
      </div>
    );
  });

  return (
    <span>
      <div className="ui form">
        <div>
          <label className="placeholder-label  no-bold color-placeholder mrtnull pdtnull">
            {APP.LANGUAGE.WaitingAreaOperatingHours.TimeZonePlaceholder}
          </label>
          <div className="mrls word-break">{' ' + getTimeZoneText()}</div>
        </div>

        <div className="mrbs show-on-small-ress " />

        <div className="mrtl">
          <label className="placeholder-label no-bold color-placeholder div-like">
            {APP.LANGUAGE.WaitingAreaOperatingHours.WaitingAreaAvailability}
          </label>
        </div>

        <div>
          <div className="mrls word-break">{serviceAvailibilty}</div>
        </div>
      </div>
      <div className="mrbs placeholder-label">
        <span>{APP.LANGUAGE.WaitingAreaOperatingHours.helpText}</span>
      </div>
      <div className="mrbs hide-on-small-ress " />
    </span>
  );
}
